// Filename: uiarticle.js
// Timestamp: 2017.11.19-13:41:52 (last modified)
// Author(s): bumblehead <chris@bumblehead.com>

import uitagslist from './uitagslist.js'
import uiarticlebyline from './uiarticlebyline.js'

const xvnode = (ss, cfg, gr, nd, ndx, subj) => {
  const tags = cfg.h
  const div = tags.div(nd)
  const { h1, b, time, a, i, main } = tags
  const {
    title,
    author,
    typelabel,
    typehref,
    datepublished,
    content,
    tagslabel,
    tagslist
  } = subj

  return (
    main([
      h1(title),
      uiarticlebyline(cfg, [
        b(author),
        a({href: typehref, title: typelabel}, typelabel),
        time(datepublished)
      ]),
      div('.readable', {
        dangerouslySetInnerHTML: {
          __html: content
        }
      }),
      div('.tags', [
        i(tagslabel),
        uitagslist.xvnode(ss, cfg, gr, nd, uitagslist, {
          tags: (tagslist && tagslist.length)
            ? tagslist
            : ['none']
        })
      ])
    ])
  )
}

export default {
  type: 'uiarticle',
  xvnode
}
